import { Component, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { MenuModel } from '../../models/menu.model';
import { SeguridadService } from '../../service/seguridad.service';
import { PublicNavigationStateService } from '../../service/public-navigation-state.service';
import { UtilService } from 'src/app/shared/service/util.service';
import { PublicNavigationDataService } from '../../service/public-navigation-data.service';

@Component({
  selector: 'app-topbar',
  templateUrl: './topbar.component.html',
  styleUrls: ['./topbar.component.css']
})
export class TopbarComponent implements OnInit, OnDestroy {
  divClass: string = 'color-transparante';
  navClass = 'topbar-public';
  arrayMenu: MenuModel[] = [];
  nameMenu = '';
  isAuthenticate = false;
  isHeroVisible = true;
  isHomeRoute = false;

  private readonly subscriptions = new Subscription();

  constructor(
    private router: Router,
    private seguridadService: SeguridadService,
    public utilService: UtilService,
    private publicNavigationStateService: PublicNavigationStateService,
    private publicNavigationDataService: PublicNavigationDataService
  ) {}

  ngOnInit() {
    this.publicNavigationDataService.ensureInitialized();

    this.subscriptions.add(
      this.publicNavigationStateService.isHeroVisible$.subscribe((isVisible) => {
        this.isHeroVisible = isVisible;
      })
    );
    this.subscriptions.add(
      this.publicNavigationDataService.menuItems$.subscribe((items) => {
        this.arrayMenu = items;
      })
    );
    this.subscriptions.add(
      this.publicNavigationDataService.isAuthenticate$.subscribe((isAuthenticate) => {
        this.isAuthenticate = isAuthenticate;
      })
    );
    this.subscriptions.add(
      this.publicNavigationDataService.nameMenu$.subscribe((nameMenu) => {
        this.nameMenu = nameMenu;
      })
    );
    this.subscriptions.add(
      this.router.events.subscribe((event) => {
        if (event instanceof NavigationEnd) {
          this.updateRouteState(this.router.url);
        }
      })
    );

    this.updateRouteState(this.router.url);
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  cerrarSesion(): void {
    this.seguridadService.logout();
  }

  irVisorGeoBosques(): void {
    // Mantiene el mismo contrato actual del item de menu.
  }

  get shouldHideTopbar(): boolean {
    return this.isHomeRoute && this.isDesktopViewport() && !this.isHeroVisible;
  }

  get shouldShowSpacer(): boolean {
    if (this.shouldHideTopbar) {
      return false;
    }

    return !this.isDesktopViewport() || !this.isHomeRoute;
  }

  private updateRouteState(url: string): void {
    this.isHomeRoute = url === '/home';
    this.divClass = this.isHomeRoute ? 'color-transparante' : 'color-verde';
    this.navClass = this.isHomeRoute
      ? 'topbar-public'
      : 'topbar-public topbar-public--fixed-desktop';
  }

  private isDesktopViewport(): boolean {
    return window.innerWidth >= 992;
  }
}